import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorQueryKey } from '@/modules/operator/keys'
import {
	GetUploadFileUrlResponse,
	GetUploadlFileUrlRequest,
} from '@/modules/operator/type'
import { getArrowLuckyWheelImageUploadFileUrl } from '../../services'

interface CreateFileUrlParams {
	payload: GetUploadlFileUrlRequest
}

export default function useMutationCreateArrowLuckyWheelImageFileUrl(
	props?: UseBaseMutationOptions<GetUploadFileUrlResponse, CreateFileUrlParams>,
) {
	return useMutation({
		mutationKey: [OperatorQueryKey.GetUploadArrowLuckyWheelImageFileUrl],
		mutationFn: (params) =>
			getArrowLuckyWheelImageUploadFileUrl(params.payload),
		...props,
	})
}
